import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DeviceService {
  private deviceType!: string;
  private userAgent!: string;

  public setDeviceType(deviceType: string) {
    this.deviceType = deviceType;
  }

  public getDeviceType() {
    return this.deviceType;
  }

  public setUserAgent(userAgent: string) {
    this.userAgent = userAgent;
  }

  public getUserAgent() {
    return this.userAgent;
  }
}
